export const escapeHtml = (value) =>
  String(value).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);

/**
 * A store's website from the ERP as a link: { href, label }, or null when the value isn't a web
 * address. Some values already start with "https://" (the card used to add a second one), some
 * are an email address or have the account number stuck to the domain ("co.uk2000253"); those
 * are left out until the ERP is corrected.
 */
export const storeWebsite = (value) => {
  const text = String(value ?? "").trim();
  if (!text || /[\s@]/.test(text)) {
    return null;
  }

  const href = /^https?:\/\//i.test(text) ? text : `https://${text}`;
  let host;
  try {
    host = new URL(href).hostname;
  } catch {
    return null;
  }

  // a real domain ends in letters: "co.uk2000253" doesn't
  const ending = host.split(".").pop();
  if (!host.includes(".") || !/^([a-z]{2,}|xn--[a-z0-9-]+)$/i.test(ending)) {
    return null;
  }

  return { href, label: text.replace(/^https?:\/\//i, "").replace(/\/$/, "") };
};
